var IMAGE_PLACEMENT_ANIMATIONS = {
    NO_EFFECT: 'NO_EFFECT',
    SLIDE: 'SLIDE',
};
export default IMAGE_PLACEMENT_ANIMATIONS;
//# sourceMappingURL=imagePlacementAnimations.js.map